import React, { Component, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import {getAvailabilityObjetive} from '../../../../../../services/getAvailability'
import { reportFetchError } from '../../../../../../observability/rum';
import { intlFormat } from 'date-fns';
import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

class AvailibilityGlobalObjetive extends Component {

    constructor(props) {
        //console.log('props destino', props)
        super(props);
        this.state = {
            objective:props.data.data,
            Availability:{},
            isLoading:true,
            user:sessionStorage.getItem("user"),
            token:sessionStorage.getItem("key"),

        }
    }
    
    componentDidMount() {
        this.processData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.t !== prevProps.t) {
            this.processData();
        }
    }
    // Helper para procesar la data de la petición a la API
    
    processData = () => {
        const {user, token, objective}=this.state
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if(objective.estado==="No monitoreo"){
            this.setState({
                Availability:t('text.no-data'),
                isLoading:false
            })
        }else{
            getAvailabilityObjetive(this.state.objective.objetivo_id, "h",user, token ).then(data => {
                var availability=data.data.uptime+data.data.parcial+data.data['evento_cliente']+data.data['marcado_atentus']
                if (typeof(availability) == 'number' && availability % 1 != 0){
                    availability = availability.toFixed(2)
                    if (availability >= 100) {
                        availability = 100
                    }
                }
                this.setState({
                    Availability:String(availability)+"%",
                    isLoading:false
                })
            }).catch(error => {
                if(this.state.isLoading===true){
                    this.setState({
                        Availability:t('text.no-data'),
                        isLoading:false
                    })
                }
                reportFetchError('AvailabilityGlobalObjetive', error)
            })
        }
    }
    
    render() {
        const {  isLoading, Availability } = this.state;
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (isLoading===true) {
            return(
                <PortletContent >
    
                        <Typography
                          variant="h5"
                          style={{color:"white"}}
                          align="center"
                        >
                         <CircularProgress
                          variant="indeterminate"
    
                          size={24}
                          thickness={4}
                          
                        />
                        <br/>
                        {t('text.loading')}
                       </Typography>
                </PortletContent>
            )
        }else if(isLoading===false){
            return(
                <Grid item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                >
                    <Typography
                          variant="h3"
                          style={{color:"white", fontSize: "40px"}}
                        >{Availability}
                    </Typography>
                </Grid>
            )
        }

    }
}



export default compose(withRouter, withTranslation())(AvailibilityGlobalObjetive);